import React from "react"
import ReactHtmlParser from "react-html-parser"
import NewsContentImageBlock from "./news-content-image-block"
import ArticleColorUsp from "../../article-color-usp/article-color-usp-component"
import { NumberCard } from "../../number-cards-container/number-cards-container-component"
import * as SelectionFactoryHelper from "../../helpers/SelectionFactoryHelper"
import { generateRandomString } from "../../../helpers/keys"

export default function NewsContent(props) {
  const blockContent = props.blockContent && props.blockContent[0]
  const contentPosition = SelectionFactoryHelper.getFromSelectionFactory(props.contentPosition)
  let componentToRender

  if (blockContent) {
    switch (blockContent.__type__) {
      case "NewsArticleImageBlock":
        componentToRender = (
          <div className={`${contentPosition}-image-block`}>
            <NewsContentImageBlock
              altText={blockContent.altText}
              imageCaption={blockContent.imageCaption}
              newsArticleImage={blockContent.newsArticleImage}
            />
          </div>
        )
        break
      case "ArticleColorUspBlock":
        componentToRender = (
          <div className={`${contentPosition}-color-usp-module`}>
            <div className="article-color-usp-module">
              <ArticleColorUsp
                headline={blockContent.headline}
                title={blockContent.title}
                titleBoxColor={blockContent.titleBoxColor}
                titleBoxTextColor={blockContent.titleBoxTextColor}
                uspBoxColor={blockContent.uspBoxColor}
                uspBoxTextColor={blockContent.uspBoxTextColor}
                uspTexts={blockContent.uspTexts}
                modifier={"w--wider"}
              />
            </div>
          </div>
        )
        break
      case "NumberCardBlock":
        componentToRender = (
          <div className={`${contentPosition}-number-card`}>
            <div className="number-cards-container">
              <NumberCard
                key={generateRandomString()}
                icon={blockContent.icon[0] || null}
                number={blockContent.precisionNumber}
                description={blockContent.description}
                displayPercent={blockContent.displayPercent}
                displayMillions={blockContent.displayMillions}
                additionalPrefixes={blockContent.additionalPrefixes}
                additionalSuffixes={blockContent.additionalSuffixes}
                lang={document.body.dataset.language}
              />
            </div>
          </div>
        )
        break
      default:
        componentToRender = null
    }
  }

  return (
    <>
      <section data-epi-property-name="ArticleText" className="news-content-section w--narrow rich-text">
        {componentToRender}
        {ReactHtmlParser(props.articleText)}
      </section>
    </>
  )
}
